import React, { useState } from 'react';
export default function SelezionaCliente({ value, onSelect }) {
  const [query, setQuery] = useState('');
  const [rows, setRows] = useState([]);
  const search = async event => {
    event.preventDefault();
    if (!query.trim()) return;
    const response = await fetch(`/api/contatti?ricerca=${encodeURIComponent(query.trim())}`);
    if (response.ok) setRows(await response.json());
  };
  return <section><p>Contatto cliente in rubrica: {value || 'nessuno'}</p>
    <form onSubmit={search}><input placeholder="Cerca cliente esistente" value={query} onChange={e => setQuery(e.target.value)} /> <button type="submit">Cerca</button></form>
    {rows.map(row => <p key={row.id}>{row.nome} · {row.codice_fiscale}
      {' '}<button type="button" onClick={() => { onSelect(row); setRows([]); }}>Collega alla pratica</button></p>)}
  </section>;
}
